<template>
  <v-card flat>
    <v-toolbar v-if="toolbar" height="60" dark flat color="primary">
      <v-toolbar-title class="hidden-xs-only"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-sheet class="scroll-y text-start scroll-target px-4" :style="'overflow-x: hidden; height: ' + (windowSize.y - 60 - 50 - 60) + 'px;'">
      <template v-if="history.length != 0">
        <template v-for='(emoji, index) in history'>
          <span class="clickable emoji" dark :key="index + '_history_' + index" @click='onEmojiClick(emoji)' style="max-height: 38px; font-size: 32px;"> {{ getEmoji(emoji) }}</span>
        </template>
        <v-divider></v-divider>
      </template>
      <template v-for="(emojis, uindex) in unicodes">
        <template v-for='(emoji, index) in emojis'>
          <span class="clickable emoji" dark :key="uindex + '_' + index" @click='onEmojiClick(emoji)' style="max-height: 38px; font-size: 32px;"> {{ getEmoji(emoji) }}</span>
        </template>
      <v-divider :key="uindex"></v-divider>
      </template>
    </v-sheet>
    <v-card-text class="text-sm-center text-center pa-0" style="height: 50px;">
      <template v-if="skins.length != 0">
        <template v-for='(emoji, index) in skins'>
          <span v-if="skinsIndex == index" :key='index' @click='onSelect(index)' class="select clickable"> {{ getEmoji(emoji) }} </span>
          <span v-else :key='index' @click='onSelect(index)' class="none clickable"> {{ getEmoji(emoji) }} </span>
        </template>
      </template>
      <template v-else>
        <v-icon dark large class="pa-1 none">mdi-emoticon-outline</v-icon>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn rounded depressed @click.native='onClose()' class='mr-2 mb-2'>
        <span>{{ '取消' }}</span>
      </v-btn>
      <v-btn v-if="skins.length != 0" rounded depressed color='primary' dark @click.native='onSubmit' class='mr-2 mb-2'>
        <span>{{ '選択' }}</span>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { arrayUnicodes } from './Emoji.js'
import { multiUnicodes } from './Multi.js'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    })
  },
  data () {
    return {
      tabs: 0,
      history: [],
      emojis: [],
      skins: [],
      skinsIndex: 0,
      unicodes: [],
      groupIcons: [
        'emoji_people.png',
        'emoji_nature.png',
        'emoji_food-and-drink.png',
        'emoji_activity.png',
        'emoji_travel-and-places.png',
        'emoji_objects.png',
        'emoji_objects-and-symbols.png',
        'emoji_flags.png'
      ]
    }
  },
  props: ['toolbar'],
  created () {
    if (localStorage.getItem('emojis') === null) {
      localStorage.setItem('emojis', JSON.stringify([]))
    }
    this.history = JSON.parse(localStorage.getItem('emojis'))
    this.unicodes = arrayUnicodes
    this.skins = []
    this.skinsIndex = 0
  },
  methods: {
    onClose () {
      this.$emit('dismissed')
    },
    getEmoji (emoji) {
      var char = ''
      emoji.map(function (value) {
        char = char + String.fromCodePoint(value)
      })
      return char
    },
    onEmojiClick (emoji) {
      emoji = JSON.parse(JSON.stringify(emoji))
      var check = false
      this.skinsIndex = 0
      multiUnicodes.forEach(function (code) {
        if (code.toString() === emoji.toString()) {
          check = true
        }
      })
      this.skins = []
      if (check) {
        this.skins[0] = emoji
        var skinPatern = [
          0x0001f3fb,
          0x0001f3fc,
          0x0001f3fd,
          0x0001f3fe,
          0x0001f3ff
        ]
        for (var i = 1; i < skinPatern.length + 1; i++) {
          var newcode = []
          var insert = false
          for (var index in emoji) {
            if (emoji[index] === 0x200d) {
              newcode.push(skinPatern[i - 1])
              insert = true
            }
            if (emoji.length === 5 && parseInt(index) === 1) {
            } else {
              newcode.push(emoji[index])
            }
          }
          if (!insert) {
            newcode.push(skinPatern[i - 1])
          }
          this.skins[i] = newcode
        }
      } else {
        this.skins[0] = emoji
      }
    },
    onSelect (select) {
      this.skinsIndex = select
    },
    onSubmit () {
      if (this.skins.length !== 0) {
        var temp = JSON.parse(localStorage.getItem('emojis'))
        temp.push(this.skins[0])
        if (temp.length > 40) {
          temp.shift()
        }
        localStorage.setItem('emojis', JSON.stringify(temp))

        this.$emit('click', this.getEmoji(this.skins[this.skinsIndex]))
      }
      this.onClose()
    }
  }
}
</script>

<style scoped>
.emoji-picker .emoji-content{
  margin-top: 10px;
  overflow-y: auto;
  height: 200px;
}
span.select {
  border: 2px solid;
  border-color: #ddd;
  border-radius:8%;
  height: 50px !important;
  width: 50px !important;
  color: rgba(0,0,0,1);
  text-align: center !important;
  font-size: 46px;
  padding-top: 14px;
  display: inline-block;
}
span.none {
  border: 2px solid;
  border-color: #fff;
  height: 50px !important;
  width: 50px !important;
  color: rgba(0,0,0,0.6);
  text-align: center;
  font-size: 46px;
  padding-top: 14px;
  display: inline-block;
}

span.clickable {
  cursor: pointer;
}

span.emoji {
  font-family: "Noto Color Emoji", "Apple Color Emoji", "Segoe UI Emoji";
  padding: 0px 0px 0px 2px;
  margin: 0;
  line-height: 38px;
  vertical-align: middle;
  display: inline-block;
}

</style>
